import { render, staticRenderFns } from "./NaoxjStockStatisticsClient.vue?vue&type=template&id=03b8426d&scoped=true&"
import script from "./NaoxjStockStatisticsClient.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockStatisticsClient.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockStatisticsClient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NaoxjStockStatisticsClient.vue?vue&type=style&index=1&id=03b8426d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8426d",
  null
  
)

export default component.exports